export const decodeToken = (token) => {
  const result = JSON.parse(atob(token.split('.')[1]));
  return result;
};

/**
 * Safe subscriber lookup for analytics — never throws on a missing/invalid token.
 * @param {string} [token] access_token
 * @returns {string|null}
 */
export const getSubscriberIdFromToken = (token) => {
  try {
    return decodeToken(token)?.subscriber || null;
  } catch {
    return null;
  }
};

export const isTokenExpired = (token) => {
  const { exp } = decodeToken(token);

  return exp < Date.now() / 1000;
};
